import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import DataUtil from "../../../actions/data.js";
import API from "../../../actions/api-helper.js";
import UI from "../../../actions/ui-helper.js";

import "./css/inicio.css";

class Inicio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contagem: {
        totalUsuarios: 0,
        totalPacientes: 0,
        totalAtendimentos: 0,
        totalReunioes: 0,
      },
      consulta: {
        periodoDe: DataUtil.primeiroDiaMes(),
        periodoAte: DataUtil.ultimoDiaMes(),
      },
    };
    this.popularGrafico = this.popularGrafico.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    let consulta = { ...this.state.consulta };
    consulta[event.target.name] = event.target.value;
    this.setState({ consulta: consulta });
  }

  componentDidMount() {
    if (
      this.props.usuario.perfil === 2 &&
      !window.location.href.includes("_teste")
    ) {
      this.props.history.push("/atendimento/consulta");
    }

    UI.loader("show", "Aguarde, calculando...");
    API.get("/apuracao/contagem").then((json) => {
      this.setState({ contagem: json.data });
      this.popularGrafico();
    });
  }

  /* global $, Chart */
  popularGrafico() {
    let periodoDe = this.state.consulta.periodoDe;
    let periodoAte = this.state.consulta.periodoAte;

    if (!DataUtil.validarData(periodoDe)) {
      periodoDe = DataUtil.primeiroDiaMes();
    }
    if (!DataUtil.validarData(periodoAte)) {
      periodoAte = DataUtil.ultimoDiaMes();
    }
    this.setState({
      consulta: { periodoDe: periodoDe, periodoAte: periodoAte },
    });

    UI.loader("show", "Aguarde, calculando...");
    let movimento = {
      periodoDe: periodoDe,
      periodoAte: periodoAte,
      profissionalId:
        this.props.usuario.perfil <= 1 ? 0 : this.props.usuario.id,
      tipo: this.props.usuario.perfil <= 1 ? 1 : 2,
    };
    API.post("/apuracao/movimento", movimento)
      .then((json) => {
        var data = {
          labels: json.data.dias,
          datasets: [
            {
              label: "Total à receber (R$)",
              data: json.data.valores,
              backgroundColor: ["rgba(50, 150, 80, 0.1)"],
              borderColor: ["rgba(50, 150, 80, 1)"],
              borderWidth: 2,
            },
            {
              label: "Atendimentos (R$)",
              data: json.data.valoresAtendimento,
              backgroundColor: ["rgba(150, 50, 80, 0.1)"],
              borderColor: ["rgba(150, 50, 80, 1)"],
              borderWidth: 2,
            },
            {
              label: "Atividades (R$)",
              data: json.data.valoresReuniao,
              backgroundColor: ["rgba(50, 50, 180, 0.1)"],
              borderColor: ["rgba(50, 50, 180, 1)"],
              borderWidth: 2,
            },
          ],
        };

        var options = {
          scales: {
            yAxes: [
              {
                ticks: {
                  callback: function (label, index, labels) {
                    return "R$ " + label.toFixed(2);
                  },
                  min: 0,
                  beginAtZero: true,
                },
              },
            ],
          },
          tooltips: {
            callbacks: {
              title: function (item) {
                let dia = item[0].xLabel;
                return "Movimento do dia " + (dia < 10 ? "0" + dia : dia);
              },
              label: function (item) {
                return "R$ " + item.yLabel.toFixed(2);
              },
            },
          },
          plugins: {
            filler: {
              propagate: true,
            },
          },
          elements: {
            line: {
              tension: 0,
            },
          },
          maintainAspectRatio: false,
        };

        if ($("#lineChart").length) {
          var lineChartCanvas = $("#lineChart").get(0).getContext("2d");
          new Chart(lineChartCanvas, {
            type: "line",
            data: data,
            options: options,
          });
        }

        UI.loader("hide");
      })
      .catch((json) => {
        UI.alert(json.success, json.message);
      });
  }

  render() {
    let cardClass =
      this.props.usuario.perfil <= 1
        ? "col-md-6 col-lg-3"
        : "col-md-6 col-lg-4";
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card card-statistics animated bounceInLeft">
              <div className="card-body p-0">
                <div className="row">
                  {this.props.usuario.perfil <= 1 && (
                    <div className={cardClass}>
                      <div className="d-flex justify-content-between border-right card-statistics-item">
                        <div>
                          <h1>{this.state.contagem.totalUsuarios}</h1>
                          <p className="text-muted mb-0">Usuários</p>
                        </div>
                        <i className="icon-user text-primary icon-lg" />
                      </div>
                    </div>
                  )}
                  <div className={cardClass}>
                    <div className="d-flex justify-content-between border-right card-statistics-item">
                      <div>
                        <h1>{this.state.contagem.totalPacientes}</h1>
                        <p className="text-muted mb-0">Pacientes</p>
                      </div>
                      <i className="icon-user text-primary icon-lg" />
                    </div>
                  </div>
                  <div className={cardClass}>
                    <div className="d-flex justify-content-between border-right card-statistics-item">
                      <div>
                        <h1>{this.state.contagem.totalAtendimentos}</h1>
                        <p className="text-muted mb-0">Atendimentos</p>
                      </div>
                      <i className="icon-book-open text-primary icon-lg" />
                    </div>
                  </div>
                  <div className={cardClass}>
                    <div className="d-flex justify-content-between card-statistics-item">
                      <div>
                        <h1>{this.state.contagem.totalReunioes}</h1>
                        <p className="text-muted mb-0">Reuniões</p>
                      </div>
                      <i className="icon-people text-primary icon-lg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row animated bounceInRight">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="row form-group">
                  <div className="col-md-6">
                    <h4 className="card-title">
                      Movimento de{" "}
                      {DataUtil.mesPorExtenso(this.state.consulta.periodoDe)}
                    </h4>
                  </div>
                  <div className="col-md-6 text-right">
                    {/*<DateRangePicker />*/}
                  </div>
                  {/* <div className="col-md-6">
                    <div className="input-group">
                      <InputMask
                        placeholder="DATA INICIAL"
                        name="periodoDe"
                        className="form-control date-field"
                        mask="99/99/9999"
                        value={this.state.consulta.periodoDe}
                        onChange={this.handleChange}
                      />
                      <InputMask
                        placeholder="DATA FINAL"
                        name="periodoAte"
                        className="form-control date-field"
                        mask="99/99/9999"
                        value={this.state.consulta.periodoAte}
                        onChange={this.handleChange}
                      />
                      <button onClick={this.popularGrafico} className="btn btn-default">
                        <i className="fa fa-search" />
                      </button>
                    </div>
                  </div> */}
                </div>
                <div style={{ height: "300px" }}>
                  <canvas id="lineChart" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(Inicio);
